function getUpdatedAllIds(state, action) {
    if (action.payload.fileInfo.parentId) {
        const parentLocation = state.allIds.indexOf(action.payload.fileInfo.parentId);
        if (parentLocation !== -1) {
            const newAllIds = [...state.allIds];
            newAllIds.splice(parentLocation + 1, 0, action.payload.fileInfo.id);
            return newAllIds;
        }
    }
    return [...state.allIds, action.payload.fileInfo.id];
}
export function addSingleFileReducer(state, action) {
    if (state.allIds.includes(action.payload.fileInfo.id)) {
        return state;
    }
    return Object.assign(Object.assign({}, state), { byId: Object.assign(Object.assign({}, state.byId), { [action.payload.fileInfo.id]: action.payload.fileInfo }), allIds: getUpdatedAllIds(state, action) });
}
//# sourceMappingURL=addSingleFileReducer.js.map